import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { registerGiftCard } from '../helpers/register-gift-card';
import { getDefaultBillingProfile } from '../helpers/get-default-billing-profile';

interface RegisterAndRedeemGiftCardFnPayload {
    expDate: string;
    cvc: string;
    cardNumber: string;
}

export type RegisterAndRedeemGiftCardFn = (
    payload: RegisterAndRedeemGiftCardFnPayload,
) => Promise<{ giftCardAmount: number }>;

export function initRegisterAndRedeemGiftCardFn({
    dependencies,
    countryCodeDefault,
}: DomainInitPayload): RegisterAndRedeemGiftCardFn {
    const { clientSdk } = dependencies;
    return async ({
        cvc,
        expDate,
        cardNumber,
    }: RegisterAndRedeemGiftCardFnPayload) => {
        const { giftCardTokenId, giftCardAmount } = await registerGiftCard(
            dependencies,
            {
                cvc,
                expDate,
                cardNumber,
                country: countryCodeDefault.toUpperCase() as 'US' | 'CA',
            },
        );
        try {
            const { id: billingProfileId } =
                await getDefaultBillingProfile(dependencies);
            await clientSdk.commerce.billing.redeemGiftCard(
                billingProfileId,
                giftCardTokenId,
            );
            // TODO: add analytics if needed
            return {
                giftCardAmount,
            };
        } catch (error: any) {
            if (
                error?.code ===
                'commerceTeam.giftCardServiceError.location_conflict'
            ) {
                throw new Error('COUNTRY_ERROR');
            } else if (
                error?.payload?.path ||
                error?.code ===
                    'commerceTeam.giftCardServiceError.gift_card_bad_data'
            ) {
                throw new Error('BAD_DATA_RETURNED');
            } else {
                /**
                 * TODO:
                 * Log error to error logger (not analytics).
                 */
                throw new Error('SYSTEM');
            }
        }
    };
}
